// Flagship "Current action" tab.
// This is the screen Codex is designing first: once the design lands, my
// next bot styles it here.
import type { ReactNode } from 'react';
import { TabPlaceholder } from './TabPlaceholder.js';
import type { ActionResponse, AuditQueryResponse } from '../api/types.js';

// Type-only imports so the wiring plan is compiled against the real
// runtime API contract even before the API calls are hooked up.
export type CurrentActionWiring = {
  latestAction?: ActionResponse;
  recentAudit?: AuditQueryResponse;
};

export function CurrentAction(): ReactNode {
  return (
    <TabPlaceholder
      tabName="Current action"
      wiringNotes="Pulls the top ranked next best action for this contact from the runtime API and the most recent audit entries via POST /v1/audit/query. Codex's flagship design fills this screen."
    />
  );
}
